import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/brand/hyundai/saws")({
  beforeLoad: () => {
    throw redirect({ href: "/brand/hyundai/chainsaws", replace: true });
  },
  component: () => null,
});
